// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
export const environment = {
  production: false,
  wmaiAPIServer: 'https://api-wmai.stage.sardegnaturismocloud.it/api/connector',
  api_url: 'https://api-wmai.stage.sardegnaturismocloud.it/api/connector',
  //wmaiAPIServer: 'http://localhost:8001/api/connector',
  //api_url: 'http://localhost:8001/api/connector',
  googleAnalyticsKey: 'UA-146703351-1',
  googleTagManager: 'GTM-PRG7567',
  inspectletTag: '00000000',
  authEndPoint: {
    responseUrl: 'https://intenseweb.stage.sardegnaturismocloud.it/#/ssoreturn/',
    idmUrl: 'https://accessmanager.demo.sardegnait.it/access-manager/oauth/authorize?response_type=code&client_id=dev.wmai.regionesardegna.it&redirect_uri=https://intenseweb.stage.sardegnaturismocloud.it/#/ssoreturn/&scope=read',
    client_id: 'dev.wmai.regionesardegna.it',
    client_secret: '12345678',
    access_token_uri: 'https://accessmanager.demo.sardegnait.it/access-manager/oauth/token',
    user_authorization_uri: 'https://accessmanager.demo.sardegnait.it/access-manager/oauth/authorize',
    grant_type: 'authorization_code',
    scope: 'read',
    host: 'https://accessmanager.demo.sardegnait.it/access-manager'
  },
  sentryDSN: "https://74559c12720d4748a72bf29f9569ffa0@o384615.ingest.sentry.io/5527655",
};

export const fireEnvironment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyDrmeE22h8eHulzzEJjqAnJEfDZqD_GjVo',
    authDomain: 'wmai-16b30.firebaseapp.com',
    databaseURL: 'https://wmai-16b30.firebaseio.com',
    projectId: 'wmai-16b30',
    storageBucket: 'wmai-16b30.appspot.com',
    messagingSenderId: '1085374721867',
    appId: '1:1085374721867:web:47e9ff6d690b52decf82ce',
    measurementId: 'G-Q09KWS1JY3'
  }
};